/**
 * Cart-upsell "Maak het compleet".
 *
 * Kiest maximaal 3 aanvullende artikelen op basis van wat er in de winkelmand
 * ligt en biedt ze aan met een 1-klik toevoegen-knop. Werkt zowel in de
 * cart-drawer als op /cart.
 *
 * Bron van de catalogus: <script id="bxsi-upsell-catalog"> uit snippets/cart-upsell.liquid.
 */
(function () {
  window.bxsi = window.bxsi || {};

  var MAX_SUGGESTIONS = 3;

  // Volgorde waarin we aanbieden wanneer er een bed in de mand ligt.
  var ORDER_WITH_BED = [
    'Hoeslaken', 'Molton', 'Hoofdkussen', 'Dekbed', 'Dekbedovertrek', 'Nachtkastje',
  ];
  // Zonder bed: dan is beddengoed het startpunt, niet de aanvulling.
  var ORDER_WITHOUT_BED = [
    'Hoofdkussen', 'Dekbed', 'Hoeslaken', 'Dekbedovertrek', 'Molton', 'Nachtkastje',
  ];

  var BED_TYPES = ['Boxspring', 'Ledikant'];

  // Bedbreedte -> passende dekbed/overtrek-maat.
  var DUVET_FOR_BED = { 90: '140', 120: '140', 140: '140', 160: '200', 180: '200', 200: '240' };

  var upsell = {
    catalog: null,
    busy: false,

    init: function () {
      var el = document.getElementById('bxsi-upsell-catalog');
      if (!el) return;
      try {
        this.catalog = JSON.parse(el.textContent);
      } catch (err) {
        console.error('Upsell-catalogus kon niet gelezen worden:', err);
        return;
      }
      if (!this.catalog || !this.catalog.length) return;

      // Drawer geeft na elke render zijn cart door.
      document.addEventListener('bxsi:cart:rendered', function (e) {
        upsell.update(e.detail && e.detail.cart);
      });

      // Los toevoegen-knoppen (event delegation, overleeft herrenderen).
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-upsell-add]');
        if (!btn) return;
        e.preventDefault();
        upsell.add(btn);
      });

      // Op /cart is er geen drawer-render, dus zelf ophalen.
      if (document.querySelector('[data-upsell-context="page"]')) {
        this.fetchAndUpdate();
      }
    },

    fetchAndUpdate: function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { upsell.update(cart); })
        .catch(function (err) { console.error('Upsell: /cart.js mislukt', err); });
    },

    /** "160 x 210 cm" -> {w:160, l:210}. Geeft null als er geen maat in zit. */
    parseDims: function (text) {
      var m = String(text || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/);
      return m ? { w: parseInt(m[1], 10), l: parseInt(m[2], 10) } : null;
    },

    /** Maat van het bed in de mand, of null. */
    bedSize: function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (!this.isBed(item)) continue;
        var props = item.properties || {};
        var dims = this.parseDims(props.Maat || item.variant_title);
        if (dims) return dims;
      }
      return null;
    },

    isBed: function (item) {
      var props = item.properties || {};
      if (props.Model) return true;
      return BED_TYPES.indexOf(item.product_type) !== -1;
    },

    hasBed: function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (this.isBed(cart.items[i])) return true;
      }
      return false;
    },

    /**
     * De maat die we zoeken voor dit producttype, gegeven het bed in de mand.
     *
     * strictWidth = de breedte MOET kloppen. Een hoeslaken of molton van 180
     * past nu eenmaal niet op een bed van 200, dus dan bieden we liever niets
     * aan dan iets dat de klant moet terugsturen. De lengte mag wel afwijken:
     * daarvoor pakken we de dichtstbijzijnde beschikbare maat.
     */
    targetFor: function (type, bed) {
      if (type === 'Hoeslaken' || type === 'Molton') {
        return { w: bed.w, l: bed.l, strictWidth: true };
      }
      if (type === 'Dekbed' || type === 'Dekbedovertrek') {
        var w = DUVET_FOR_BED[bed.w];
        // Dekbedden komen alleen in lengte 220.
        return w ? { w: parseInt(w, 10), l: 220, strictWidth: false } : null;
      }
      return null; // kussens en meubels hebben geen maatrelatie met het bed
    },

    /**
     * Kiest de best passende variant bij het bed in de mand.
     * Geeft null als er geen passende maat bestaat (dan slaan we het product over).
     */
    pickVariant: function (product, bed) {
      var available = product.variants.filter(function (v) { return v.available; });
      if (!available.length) available = product.variants.slice();
      if (!available.length) return null;

      var cheapest = available.slice().sort(function (a, b) { return a.price - b.price; })[0];
      if (!bed) return cheapest;

      var target = this.targetFor(product.type, bed);
      if (!target) return cheapest;

      var self = this;
      var sized = available
        .map(function (v) { return { v: v, d: self.parseDims(v.title) }; })
        .filter(function (x) { return x.d; });
      if (!sized.length) return cheapest; // product zonder maten in de titel

      var pool = sized.filter(function (x) { return x.d.w === target.w; });

      if (!pool.length) {
        if (target.strictWidth) return null; // past niet, dus niet aanbieden
        var minDw = Math.min.apply(null, sized.map(function (x) {
          return Math.abs(x.d.w - target.w);
        }));
        pool = sized.filter(function (x) { return Math.abs(x.d.w - target.w) === minDw; });
      }

      // Dichtstbijzijnde lengte; bij gelijke afstand de goedkoopste.
      pool.sort(function (a, b) {
        return Math.abs(a.d.l - target.l) - Math.abs(b.d.l - target.l) || a.v.price - b.v.price;
      });
      return pool[0].v;
    },

    suggest: function (cart) {
      if (!cart || !cart.items || !cart.items.length) return [];

      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });

      var bed = this.bedSize(cart);
      var order = this.hasBed(cart) ? ORDER_WITH_BED : ORDER_WITHOUT_BED;

      var picked = [];
      for (var t = 0; t < order.length && picked.length < MAX_SUGGESTIONS; t++) {
        var type = order[t];
        var self = this;
        var candidates = this.catalog
          .filter(function (p) { return p.type === type && !inCart[p.id]; })
          .map(function (p) { return { product: p, variant: self.pickVariant(p, bed) }; })
          .filter(function (c) { return c.variant; });

        // Laagste instapprijs eerst: een goedkoop bijproduct haakt beter aan dan
        // het duurste uit de categorie. Maakt de keuze ook onafhankelijk van de
        // sorteervolgorde van de collectie in admin.
        candidates.sort(function (a, b) { return a.variant.price - b.variant.price; });

        // Hooguit 1 product per categorie, anders staan er 3 kussens onder elkaar.
        if (candidates.length) picked.push(candidates[0]);
      }
      return picked;
    },

    update: function (cart) {
      var boxes = document.querySelectorAll('[data-cart-upsell]');
      if (!boxes.length) return;
      if (!cart || !cart.items || !cart.items.length) {
        boxes.forEach(function (b) { b.hidden = true; });
        return;
      }

      var picks = this.suggest(cart);
      var self = this;
      boxes.forEach(function (box) {
        var list = box.querySelector('[data-upsell-list]');
        if (!list) return;
        if (!picks.length) { box.hidden = true; return; }
        list.innerHTML = picks.map(function (p) { return self.card(p); }).join('');
        box.hidden = false;
      });
    },

    money: function (cents) {
      return '€' + ((cents || 0) / 100).toLocaleString('nl-NL', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    },

    esc: function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    },

    card: function (pick) {
      var p = pick.product;
      var v = pick.variant;
      var sub = v.title && v.title !== 'Default Title' ? this.esc(v.title) : this.esc(p.type);
      var img = p.image
        ? '<img src="' + this.esc(p.image) + '" alt="" loading="lazy" width="56" height="56">'
        : '<span class="bxsi-upsell__ph" aria-hidden="true"></span>';

      return '' +
        '<li class="bxsi-upsell__item">' +
          '<a class="bxsi-upsell__thumb" href="' + this.esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="bxsi-upsell__body">' +
            '<a class="bxsi-upsell__title" href="' + this.esc(p.url) + '">' + this.esc(p.title) + '</a>' +
            '<span class="bxsi-upsell__meta">' + sub + '</span>' +
          '</div>' +
          '<div class="bxsi-upsell__buy">' +
            '<span class="bxsi-upsell__price">' + this.money(v.price) + '</span>' +
            '<button type="button" class="bxsi-upsell__add" data-upsell-add="' + v.id + '"' +
              ' aria-label="Voeg ' + this.esc(p.title) + ' toe aan winkelmand">Toevoegen</button>' +
          '</div>' +
        '</li>';
    },

    add: function (btn) {
      if (this.busy) return;
      this.busy = true;

      var id = parseInt(btn.getAttribute('data-upsell-add'), 10);
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Bezig...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed ' + res.status);
          return res.json();
        })
        .then(function () {
          if (window.toast) window.toast('Toegevoegd aan winkelmand', 'info', 2000);
          document.dispatchEvent(new CustomEvent('bxsi:cart:changed', { detail: { id: id } }));

          // Drawer ververst zichzelf; op /cart moet de pagina opnieuw geladen
          // worden zodat regels, subtotaal en leverkosten kloppen.
          if (document.querySelector('[data-upsell-context="page"]')) {
            window.location.reload();
            return;
          }
          if (window.bxsi.cartDrawer) return window.bxsi.cartDrawer.fetchCart();
          return upsell.fetchAndUpdate();
        })
        .catch(function (err) {
          console.error('Upsell toevoegen mislukt:', err);
          if (window.toast) window.toast('Toevoegen mislukt, probeer opnieuw', 'error', 3000);
          btn.disabled = false;
          btn.textContent = original;
        })
        .finally(function () {
          upsell.busy = false;
        });
    },
  };

  window.bxsi.cartUpsell = upsell;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { upsell.init(); });
  } else {
    upsell.init();
  }
})();
